import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const GalleryImage = ({
  img,
  currImage,
  index,
  imageX,
  imageY,
  imagesLength,
}) => {
  return (
    <div
      className={classNames('image-wrapper', {
        'zoom-image-selected': currImage === index,
      })}
      key={index}
      style={{ width: `${100 / imagesLength}%` }}
    >
      <div className="image-container">
        <img
          className="zoom-image-box-image"
          alt={`product gallery item ${index}`}
          src={img}
          style={{ transformOrigin: `${imageX}% ${imageY}% 0` }}
        />
      </div>
    </div>
  );
};

GalleryImage.propTypes = {
  img: PropTypes.string.isRequired,
  currImage: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  imageX: PropTypes.number.isRequired,
  imageY: PropTypes.number.isRequired,
  imagesLength: PropTypes.number.isRequired,
};

export default GalleryImage;
